import React from "react";
import "./tables.styles.scss";
import { valueConverter } from '../../util-functions/util-funtions'

const total = ["Total"];

export default function TotalsTable(props) {

  return (
    <table className='totals-table'>

      <thead>
        <tr>
          {total.map((item,ind) => (
            <th className='tables-cell totals-header-cell' key={ind} >{item}</th>
          ))
          }
        </tr>
      </thead>

      <tbody>

        {props.data ?
          props.data.map((item, index) => (

            <tr key={index}>
              <td className='tables-cell'>{Object.values(item)? valueConverter(Object.values(item)[0]): "NO"}</td>
            </tr>

          ))
          :
          null
        }

      </tbody>

    </table>
  )
}
